import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
export default function BankPaymentLink({ companyId, plan, result, onShowVerification }) {
    const supplier = plan.type === 'register_supplier_payment' || plan.target.side === 'supplier';
    return <div role="status">
        <p>{result.created_payment ? 'Betalningen är registrerad.' : 'Den registrerade betalningen är kopplad.'}</p>
        <Link to={`/${companyId}/${supplier ? 'supplier-invoices' : 'view-invoice'}/${plan.target.invoice_id}`}>Visa faktura och betalning</Link>
        {onShowVerification && <Button variant="link" onClick={onShowVerification}>Visa verifikat</Button>}
    </div>;
}
